<template>
  <div class="wap page" v-if="!needWeChat">
    <div class="container">
      <Head :extras="extras" :logo="defaultRess.wap.logo" />

      <Banner :extras="extras" />
      <div class="file-list">
        <div class="no-data" v-if="fileList.length == 0">
          暂无数据
        </div>
        <div class="f-list" v-for="file in fileList" :key="file.fileId">
          <div class="list-item">
            <div class="item-top">
              <div
                class="item-cover"
                v-if="extraItem.extras('listCoverType.model') == 1"
              >
                <img :src="file.coverUrl" alt="" />
              </div>
              <div class="item-icon" v-else>
                <img :src="file.iconUrl" alt="" />
              </div>
              <div
                class="item-content"
                :class="{ icon: extraItem.extras('listCoverType.model') != 1 }"
              >
                <div
                  class="item-title"
                  :style="{
                    color: extraItem.extras('listTitle.color'),
                    fontSize: pxOrVw(extraItem.extras('listTitle.size')),
                    fontWeight:
                      extraItem.extras('listTitle.weight') == 'default'
                        ? '500'
                        : extraItem.extras('listTitle.weight')
                  }"
                >
                  {{ file.name }}
                </div>
                <!-- <div class="item-summary">
                {{ file.descInfo }}
              </div> -->
              </div>
            </div>

            <div
              class="item-foot"
              :class="{ icon: extraItem.extras('listCoverType.model') != 1 }"
              :style="{
                'margin-top':
                  extraItem.extras('fileInfo.display') != 1 ? '0' : ''
              }"
            >
              <div
                class="item-date"
                v-if="extraItem.extras('fileInfo.display') == 1"
              >
                {{ file.dateText }} <span class="icontemp chakan1"></span>
                {{ file.previewCount }} <span class="icontemp xiazai1"></span
                >{{ file.downloadCount }} <span class="icontemp wendang"></span
                >{{ file.sizeText }}
              </div>
              <div class="item-button">
                <div
                  class="button"
                  :style="{
                    color: extraItem.extras('themecolor.bgcolor'),
                    borderColor: extraItem.extras('themecolor.bgcolor')
                  }"
                  v-if="extraItem.extras('previewBtnName.display') == 1"
                  @click="onDetails(file)"
                >
                  {{ extraItem.extras("previewBtnName.model") || "预览" }}
                </div>
                <div
                  class="button"
                  :style="{
                    color: extraItem.extras('themecolor.bgcolor'),
                    borderColor: extraItem.extras('themecolor.bgcolor')
                  }"
                  v-if="extraItem.extras('downloadBtnName.display') == 1"
                  @click="onDownloadFile(file, folderData.downloadType)"
                >
                  {{ extraItem.extras("downloadBtnName.model") || "下载" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins/index.js";
import mixinTemplate from "@/mixins/template.js";
import { initWeChat } from "@/common/wx.js";
import wechat from "@/common/wechat.js";
import { URLS, $subscriber } from "fire-wind-water";
import { isSetting, updateSearchParam } from "@/common/sbase.js";
import $ from "jquery";
import cs from "@/services/commonService.js";
import URL from "@/assets/conf/setting.json";
import { ck } from "fire-wind-water";

import Head from "@/components/head";
import Banner from "@/components/banner";
export default {
  name: "WapFileList",
  props: ["folderId"],
  mixins: [mixin, mixinTemplate],
  components: { Head, Banner },
  data() {
    return {
      isWeChat: window.$ua.isWeChat,
      accKey: URLS.getURL("accKey"),
      weChatId: URLS.getURL("weChatId"),
      folderData: {},
      // 分页
      totalNum: 0,
      currentPageNum: 0,
      pageSize: 1000,
      // pageSize: 3,

      fileList: [],

      fileListLoading: false,
      fileListFinished: false,

      needWeChat: true,
      shareInfo: {
        shareImageUrl: "",
        shareTitle: "",
        description: ""
      },
      sessParam: ""
    };
  },
  methods: {
    init() {
      this.service
        .getReleaseFile({
          fileId: this.folderId
        })
        .subscribe(data => {
          if (data.result !== 0) {
            this.$toast.fail("未获取到对应文件");
            console.log("未获取到对应文件");
            return;
          }
          if (data.content && data.content.schemaId) {
            let memberInfo = ck.cookie(
              "smarketMember_" + data.content.schemaId
            );
            this.sessParam = memberInfo ? memberInfo.session : "";
          }
          this.folderData = this.cookFolderData(data.content);
          console.log(this.folderData);
          this.shareInfo = {
            imgUrl: 'http:'+ this.folderData.shareImageRealPath,
            title: this.folderData.shareTitle,
            desc: this.folderData.description,
            link: window.location.href
          };
          // console.log(JSON.stringify(this.folderData, null, 2))

          // 是否限制微信端
          if (this.folderData.openType == 1 && !window.$ua.isWeChat) {
            this.needWeChat = true;
            this.$toast({ message: "请在微信端浏览本页面！", duration: 0 });
            window.$sk && window.$sk.loading.hide();
            return;
          } else {
            this.needWeChat = false;
          }

          //          let weChatId = this.folderData.weChatId || this.weChatId;
          //
          //          cs.getDefWeChat({}).subscribe(data=>{
          //            data;
          //          })

          this.getWechatId().then(weChatId => {
            //分享设置
            let apiUrl = URL.template.api.gateway.general;
            window.$swxsdk.initWxSdk(
              { tenantId: this.folderData.tenantId, weChatId: weChatId },
              apiUrl
            );
            if (this.folderData.enableShare == 1) {
              window.$swxsdk.on("sharer", this.shareInfo);
              window.$swxsdk.on("sharer_friends", this.shareInfo);
            } else {
              window.$swxsdk.on(
                "hideMenuList",
                {
                  menuList: [
                    "menuItem:share:appMessage",
                    "menuItem:share:timeline",
                    "menuItem:share:qq",
                    "menuItem:share:weiboApp",
                    "menuItem:share:facebook",
                    "menuItem:share:QZone",
                    "menuItem:copyUrl",
                    "menuItem:openWithQQBrowser",
                    "menuItem:openWithSafari",
                    "menuItem:favorite"
                  ]
                },
                function(result) {
                  console.log(result);
                }
              );
              window.$swxsdk.on("hideOptionMenu");
              console.log('hideOptionMenu---215');
            }
            if (window.$ua.isWeChat && weChatId != 0) {
              initWeChat(this.folderData);
              wechat.weChatLoad(this.folderData.tenantId, weChatId, true).then(
                () => {
                  if (this.verifyPermission(this.folderData)) {
                    this.getContact(this.folderData);
                    this.loadFileList();
                  }
                },
                () => {
                  // 权限验证
                  if (this.verifyPermission(this.folderData)) {
                    this.getContact(this.folderData);
                    this.loadFileList();
                  }
                }
              );
            } else {
              // 权限验证
              if (this.verifyPermission(this.folderData)) {
                this.getContact(this.folderData);
                this.loadFileList();
              }
            }
          });
        });
    },
    loadFileList() {
      this.initConfig(this.folderData.wapConfigId, this.folderData.tenantId);
      if (isSetting) return;
      if (this.fileListFinished) return;
      this.fileListLoading = true;
      ++this.currentPageNum;
      let tokenInfo = ck.cookie("verifyInfo_" + URLS.getURL("weChatId"));
      let memberInfo = ck.cookie("smarketMember_" + this.folderData.schemaId);
      this.service
        .getReleaseFileList({
          folderId: this.folderId,
          accKey: this.accKey,
          num: this.pageSize,
          start: this.pageSize * (this.currentPageNum - 1),
          userSess: this.sessParam,
          globalUserId: ck.cookie("globalUserId"),
          openId: tokenInfo? tokenInfo.openId : "",
          sess: memberInfo? memberInfo.session : ""
        })
        .subscribe(data => {
          this.fileListLoading = false;
          this.totalNum = parseInt(data.content.total);
          if (this.pageSize * this.currentPageNum >= this.totalNum) {
            this.fileListFinished = true;
          }
          this.fileList = [
            ...this.fileList,
            ...this.cookFileList(data.content.items)
          ];
          // console.log(JSON.stringify(this.fileList, null, 2))
        });
    },
    onDetails(file) {
      console.log("# onDetails");
      if (window.$ua.isWeChat) {
        if (file.preview.type == 2 || file.preview.type == 3) {
          window.$sk.goto(
            updateSearchParam(
              "returnUrl",
              encodeURIComponent(window.location.href),
              file.wapUrl
            )
          );
        } else {
          if (file.previewUrl) {
            /*this.interactionPreview(file, () => {
              // window.location.href = file.previewUrl;

            });*/
            let { href } = this.$router.resolve({
              path: "/wap/filePreview",
              query: {
                fileId: file.fileId
              }
            });
            window.$sk.goto(href);
          } else {
            window.$sk && window.$sk.alert("该文件不支持预览");
          }
        }
      } else {
        if (file.preview.type == 2 || file.preview.type == 3) {
          window.location.href = updateSearchParam(
            "returnUrl",
            encodeURIComponent(window.location.href),
            file.wapUrl
          );
        } else {
          if (file.previewUrl) {
            // window.open(file.previewUrl);
            let { href } = this.$router.resolve({
              path: "/wap/filePreview",
              query: {
                fileId: file.fileId
              }
            });
            window.$sk.goto(href);
           // this.interactionPreview(file);
          } else {
            window.$sk && window.$sk.alert("该文件不支持预览");
          }
        }
      }
    },
    getWechatId() {
      let defer = $.Deferred();
      let weChatId = this.folderData.weChatId || this.weChatId;
      if (weChatId != 0) {
        defer.resolve(weChatId);
      } else {
        cs.getDefWeChat({}).subscribe(data => {
          defer.resolve(data.content.weChatId);
        });
      }
      return defer.promise();
    }
  },
  created() {
    if (isSetting) {
      this.initMockFileList();
      return;
    }
    this.init();
    $subscriber.subscribe("weChatAuthUpdate", () => {
      console.log("# weChatAuthUpdate");
      this.init();
    });
  }
};
</script>

<style lang="scss" scoped>
.file-list {
  padding: 0 30px;
  padding-bottom: 30px;
  overflow: auto;
  min-height: 500px;

  .file-item {
    display: flex;
    font-size: 24px;
    border-bottom: solid 1px rgba(238, 238, 238);

    .file-icon {
      width: 140px;
      margin-top: 10px;
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100px auto;
    }

    .file-cover {
      width: 230px;
      height: 115px;
      margin-top: 10px;
      margin-right: 50px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .file-content {
      flex: 1;
      text-align: start;
      overflow: hidden;

      .title {
        font-size: 28px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow-wrap: break-word;
        overflow: hidden;
      }

      .desc-info {
        margin-top: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .stat-info {
        margin-top: 16px;
        color: rgb(153, 153, 153);
        display: flex;

        .date {
          margin-right: auto;
        }

        .right {
          margin-left: 28px;
        }

        i {
          font-size: 24px;
          padding-right: 8px;
        }
      }

      .file-action {
        display: flex;
        align-items: center;
        margin-top: 18px;

        .action-btn {
          display: inline-block;
          max-width: 150px;
          font-size: 24px;
          line-height: 24px;
          text-align: center;
          white-space: nowrap;
          color: $color-base;
          padding: 8px 10px;
          margin-right: 25px;
          border: solid 1px $color-base;
          border-radius: 8px;
          overflow: hidden;

          i {
            font-size: 24px;
            padding-right: 5px;
          }
        }

        .size {
          white-space: nowrap;
          word-break: break-all;
        }
      }
    }
  }

  .f-list {
    margin-top: 30px;
    animation: opacityAnimate 0.3s ease-in-out;
    // margin-bottom: 30px;
  }

  .list-item {
    position: relative;
    padding: 40px 30px 60px 30px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    box-shadow: 0px 0px 10px 0px rgba(222, 222, 222, 0.43);
    border-radius: 4px;

    .item-top {
      display: flex;
    }

    .item-cover {
      position: relative;
      width: 220px;
      flex: 0 0 220px;
      height: 128px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      //background: #cbdbf2;

      img {
        display: block;
        width: 100%;
      }
    }

    .item-icon {
      position: relative;
      width: 69px;
      flex: 0 0 69px;
      img {
        width: 100%;
      }
    }

    .item-content {
      height: 135px;
      position: relative;
      color: #212121;
      margin-left: 30px;
      .item-title {
        width: 100%;
        font-weight: 600;
        font-size: 30px;
        color: #333333;
        line-height: 45px;
        word-break: break-all;
        word-break: break-word;
        @include ellipsis(3);
      }

      .item-summary {
        font-size: 26px;
        opacity: 0.62;
        height: 64px;
        line-height: 32px;
        margin-top: 10px;
        @include ellipsis(2);
      }
    }
  }
}

.file-list-footer {
  font-size: 18px;
  font-weight: bold;
  padding: 50px 0;
}

.item-foot {
  color: #999999;
  text-align: left;
  margin-top: 26px;
  .icontemp {
    margin-left: 30px;
    margin-right: 6px;
    font-size: 28px;
  }
  .item-date {
    font-size: 25px;
    font-weight: 400;
    color: #aaaaaa;
    line-height: 36px;
  }

  .item-button {
    height: 68px;
    margin-top: 26px;
    display: flex;
  }
  .button {
    flex: 1;
    /*width: 124px;*/
    min-width: 230px;
    margin-left: 30px;
    width: 230px;
    height: 68px;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid $blue;
    color: $blue;
    font-size: 30px;
    background-color: #ffffff;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 10px;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .icontemp {
      font-size: 26px;
      position: relative;
      margin-left: 0;
      top: 2px;
    }
    &:first-of-type {
      margin-left: 0;
    }
  }

  &.icon {
    padding-left: 100px;
    .item-button {
      display: block;
      .button {
        max-width: 330px;
      }
    }
  }
}

.no-data {
  position: relative;
  text-align: center;
  top: 250px;
  color: #b1b1b1;
  font-size: 18px;
}

@keyframes opacityAnimate {
  0% {
    opacity: 0;
    transform: translate(0, -10px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>
